/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Layout_Header_Join_DiscordInputs */



/**
* | output |
* | --- |
* | "Join our Discord" |
*
* @param {Layout_Header_Join_DiscordInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const layout_header_join_discord = /** @type {((inputs?: Layout_Header_Join_DiscordInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Layout_Header_Join_DiscordInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Komm auf unseren Discord")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rejoignez notre Discord")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("加入我们的 Discord")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("加入我們的 Discord")
	if (locale === "ko") return /** @type {LocalizedString} */ ("Discord 참여하기")
	return /** @type {LocalizedString} */ ("Join our Discord")
});